import Mock from 'mockjs'

Mock.mock('/api/user/login', 'post', (req) => {
  // eslint-disable-next-line standard/object-curly-even-spacing
  const { password, username } = JSON.parse(req.body)
  if (username === 'admin' && password === '111111') {
    return {
      success: true,
      errMsg: null,
      code: 200,
      data: {
        token: 'etye0fgkgk4ca2ttdsl0ae9a5dd77471fgf'
      }
    }
  } else {
    return {
      success: false,
      errMsg: null,
      code: 400
    }
  }
})

let mockUserInfo = {
  'success': true,
  'errMsg': null,
  'code': 200,
  'data': {
    'name': '@CNAME', // 随机生成中文人名
    'roles': ['admin'],
    'introduction': '@cword(50)', // 随机文字
    'avatar': '@image' // @image随机头像
  }
}

Mock.mock('/api/user/logout', 'post', (req) => {
  var token = req.body
  if (token === 'etye0fgkgk4ca2ttdsl0ae9a5dd77471fgf') {
    return {
      success: true,
      errMsg: null,
      code: 200,
      data: '退出成功'
    }
  }
})
// Mock.mock('/api/user/info', 'get', {
Mock.mock(RegExp('/api/user/info' + '.*'), 'get', (options) => {
  return Mock.mock(mockUserInfo)
})

/* const imgArray = require.context('../../static/inspectionImg/20210315/', false, /.jpg$/).keys().forEach(fileName => {
  // 剥去文件名开头的 ./ 和结尾的扩展名
  // element.replace('.', '')
  // element.replace('/', '')
  // fileName.replace(/^./(.*).\w+$/, '$1')
  fileName = require('../../static/inspectionImg/20210315/' + fileName)
}) */

// console.log(imgArray)
let imgList = {
  'success': true,
  'errMsg': null,
  'code': 200,
  'data': {
    'imglist': [
      require('../../static/inspectionImg/20210315/20210315162550.jpg'),
      require('../../static/inspectionImg/20210315/20210315162551.jpg'),
      require('../../static/inspectionImg/20210315/202103151625501.jpg'),
      require('../../static/inspectionImg/20210315/202103151625502.jpg'),
      require('../../static/inspectionImg/20210315/202103151625511.jpg'),
      require('../../static/inspectionImg/20210315/202103151625512.jpg'),
      require('../../static/inspectionImg/20210315/202103151625513.jpg'),
      require('../../static/inspectionImg/20210315/202103151625514.jpg'),
      require('../../static/inspectionImg/20210315/202103151625515.jpg')
    ]
  }
}

Mock.mock(RegExp('/api/img/downloadImg' + '.*'), 'get', (options) => {
  return Mock.mock(imgList)
})

Mock.mock(RegExp('/api/img/uploadImg' + '.*'), 'post', (req) => {
  // debugger
  // var body = JSON.parse(req.body)
  // 请求相关的参数
  console.log(req)
  var body = req.body
  if (body) {
    return {
      success: true,
      errMsg: null,
      code: 200,
      data: body.getAll('file')
    }
  } else {
    return {
      success: false,
      errMsg: null,
      code: 400
    }
  }
})



// WEBPACK FOOTER //
// ./src/api/mock.js